import React from 'react';
import { ServiceFeaturesGrid } from '../common/service-features-grid';

export function MobileServies() {
    const features = [
        {
            title: 'Native Mobile App Development',
            description:
                'Our mobile developers expertly utilize Swift, Objective-C, Java, and Kotlin to craft powerful, feature-rich native apps. With a dedicated focus on performance optimization, responsiveness, and speed, we ensure a seamless and engaging user experience for your iOS and Android apps.',
            icon: '/img/technology/ic-mobile-app.svg',
        },
        {
            title: 'Cross-platform Mobile Development',
            description:
                'With our cross-platform app development expertise, you can effortlessly target iOS and Android customer base with multiple cross-platforms like Flutter and React Native. We build mobile apps from a single codebase and integrate seamlessly using our cross-platform expertise to streamline development, save time, and gain a competitive edge.',
            icon: '/img/technology/ic-cross-platform-mobileapp.svg',
        },
        {
            title: 'Progressive Web App Development',
            description:
                'We deliver robust PWAs that provide personalized native-app user experiences and seamless offline compatibility. With our platform-agnostic solutions, we streamline progressive web app development processes so you can effortlessly reach your target audience.',
            icon: '/img/technology/ic-project-management.svg',
        },
        {
            title: 'Wearables and Embedded Software',
            description:
                'Through embedded software solutions, we optimize your intelligent systems and build hybrid wearables. By combining wearables with embedded systems, we offer you personalized experiences, remote monitoring, and data-driven insights.',
            icon: '/img/technology/ic-wearable-software.svg',
        },
        {
            title: 'Mobile App Consulting',
            description:
                'At Moweb, we offer expert advice on how to develop mobile apps by selecting the right technologies. Through thoroughly analyzing your business goals, target audience, and industry trends, we design a personalized roadmap that leads to your app\'s success.',
            icon: '/img/technology/ic-consulting-services.svg',
        },
        {
            title: 'Mobile App Design',
            description:
                'As a leading mobile app design company, we create mobile apps tailored to your unique needs. With the help of our talented UI/UX designers, we ensure that you receive a visually appealing and user-friendly app that showcases your brand.',
            icon: '/img/technology/ic-ios-uiux.svg',
        },
        {
            title: 'Testing and QA',
            description:
                'Our QA testing team is committed to ensuring flawless performance through rigorous testing and quality assurance. You can trust us to deliver a seamless user experience, allowing you to concentrate on the growth of your business with confidence.',
            icon: '/img/technology/ic-testing.svg',
        },
        {
            title: 'Maintenance and Support',
            description:
                'We prioritize your mobile app maintenance and support by updating, securing, and optimizing to help you focus on your core business. You can rely on us for timely bug fixes, feature enhancements, and a seamless user experience tailored to your specific needs.',
            icon: '/img/technology/ic-support-maintenance.svg',
        },
        {
            title: 'Mobile App Modernization',
            description:
                'With our Mobile App Modernization service, we specialize in transforming your mobile app into a cutting-edge solution. Our team of expert mobile app developers will upgrade your application to new heights, enhancing user experience and boosting performance with innovative functionalities.',
            icon: '/img/technology/ic-efficient-delivery.svg',
        },
    ];

    return (
        <>
            <div className="section-py dark:bg-black">
                <div className="container lg:container mx-auto">
                    <div className="row grid lg:grid-cols-12">
                        <div className="text-center lg:col-span-8 lg:col-start-3 pb-50">
                            <p
                                className="text-primary mb-0 fs-lg fw-700"
                                data-aos="fade-up"
                                data-aos-duration="700"
                                data-aos-delay="200"
                            >
                                We Provide
                            </p>
                            <h2
                                data-aos="fade-up"
                                data-aos-duration="700"
                                data-aos-delay="100"
                            >
                                Mobile App Development Services
                            </h2>
                        </div>
                    </div>
                <ServiceFeaturesGrid features={features} variant="default"/>
                </div>
            </div>
        </>
    );
}

export default MobileServies;